import { render, staticRenderFns } from "./CreateAlertsRoutingStatusModal.vue?vue&type=template&id=32bbe248&scoped=true&"
import script from "./CreateAlertsRoutingStatusModal.vue?vue&type=script&lang=js&"
export * from "./CreateAlertsRoutingStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateAlertsRoutingStatusModal.vue?vue&type=style&index=0&id=32bbe248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bbe248",
  null
  
)

export default component.exports